import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KYMW1309Component } from './kymw1309.component';

const routes: Routes = [
  {
    path: 'KYMW1309', component: KYMW1309Component
  }
];

/**
 * バンドルミックスマッチ検索設定クラス
 *
 * 提供時：
 * app/main/main.routing.module.ts
 *
 * @export KYMW1309RoutingModule
 * @class KYMW1309RoutingModule
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class KYMW1309RoutingModule { }
